var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDoubleArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 11,
  fill: "none",
  viewBox: "0 0 14 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#3C97AA",
  strokeWidth: 1.5,
  d: "m1 9.5 4.23-4L1 1.5m6.77 8 4.23-4-4.23-4"
})));
export { SvgDoubleArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxNCAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgOS41TDUuMjMwNzcgNS41TDEgMS41TTcuNzY5MjMgOS41TDEyIDUuNUw3Ljc2OTIzIDEuNSIgc3Ryb2tlPSIjM0M5N0FBIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8L3N2Zz4K";